export function hex2rgb(hex, opacity) {
  hex = (hex + '').trim();

  let rgb = null;
  let match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);

  if (!match) {
    return null;
  }

  rgb = {};

  hex = match[1];

  if (hex.length === 6) {
    rgb.r = parseInt(hex.substring(0, 2), 16);
    rgb.g = parseInt(hex.substring(2, 4), 16);
    rgb.b = parseInt(hex.substring(4, 6), 16);
  } else if (hex.length === 3) {
    rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
    rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
    rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
  }

  rgb.css = 'rgb' + (opacity ? 'a' : '') + '(';
  rgb.css += rgb.r + ',' + rgb.g + ',' + rgb.b;
  rgb.css += (opacity ? ',' + opacity : '') + ')';

  return rgb;
}
/**
 * Collect all the required properties in a plain object.
 *
 * @param {array} fieldNames of properties
 * @param {*} obj the object that should contain all the fields
 */
export function gather(fieldNames) {
  let gathered = {};

  for (let i = 0; i < fieldNames.length; i++) {
    const key = fieldNames[i];
    if (this.hasOwnProperty(key)) {
      gathered[key] = this[key];
    }
  }

  return gathered;
}

/**
 * Function that creates stats for all expenses
 * @param {[any]} list list of expenses
 * @returns object that collects all the statistics
 */

export function generateStatistic(list) {
  let result = {};

  // all types
  const expenseTypes = [
    'exp-travel',
    'exp-drivers',
    'exp-hotel',
    'exp-tickets',
    'exp-plain',
    'exp-insurance',
    'exp-package',
    'exp-unknown'
  ];

  // documentType: this.documentType.id,
  // documentNumber: this.documentNumber,
  // issueDate: this.date,
  // description: this.documentDescription.id,
  // measure: this.measure,
  // quantity: this.quantity,
  // price: this.price,
  // priceNotes: this.priceNotes

  expenseTypes.forEach(expenseType => {
    let filtered = list.filter(exp => exp.description === expenseType);
    let totalQuantity = 0;
    let totalPrice = 0;
    filtered.forEach(expense => {
      totalQuantity += expense.quantity;
      totalPrice += expense.quantity * expense.price;
    });
    result[expenseType] = { totalPrice, totalQuantity, expenseType };
    result[expenseType].isHidden = filtered.length === 0;

    if (expenseType === 'exp-plain' && filtered.length > 0) {
      result[expenseType].averagePrice = totalPrice / Number(totalQuantity);
    }
  });

  return result;
}

export default { hex2rgb, gather, generateStatistic };